// src/admin/components/AdminPagination.jsx
import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function AdminPagination({ total, limit, offset, onChange, itemLabel }) {
  const totalPages = Math.ceil(total / limit);
  const currentPage = Math.floor(offset / limit) + 1;

  if (totalPages <= 1) return null;

  const btnStyle = (disabled) => ({
    padding: '6px 10px', borderRadius: '6px',
    border: '1px solid rgba(0,0,0,0.1)',
    background: disabled ? '#f5f5f7' : '#ffffff',
    color: disabled ? '#c0c0c0' : '#3a3a3c',
    cursor: disabled ? 'not-allowed' : 'pointer',
    display: 'inline-flex', alignItems: 'center', gap: '4px',
    fontSize: '12px', fontFamily: "'DM Sans', sans-serif",
  });

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '12px 0' }}>
      <span style={{ fontSize: '12px', color: '#6c6c6d' }}>
        {itemLabel
          ? `${total} ${itemLabel} totali`
          : `${total} utent${total === 1 ? 'e' : 'i'} totali`}
      </span>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <button
          disabled={currentPage <= 1}
          onClick={() => onChange(Math.max(0, offset - limit))}
          style={btnStyle(currentPage <= 1)}
        >
          <ChevronLeft size={14} /> Prec
        </button>
        <span style={{ fontSize: '12px', color: '#3a3a3c', fontFamily: "'JetBrains Mono', monospace" }}>
          {currentPage} / {totalPages}
        </span>
        <button
          disabled={currentPage >= totalPages}
          onClick={() => onChange(offset + limit)}
          style={btnStyle(currentPage >= totalPages)}
        >
          Succ <ChevronRight size={14} />
        </button>
      </div>
    </div>
  );
}
